// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import userPlus01Icon from "@/assets/icons/user-plus-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type UserPlus01IconProps = Omit<IconProps, "name">;

export function UserPlus01Icon(props: UserPlus01IconProps): React.ReactNode {
  return <Icon name={userPlus01Icon} {...props} />;
}
